module.exports = __webpack_public_path__ + "media/images/about_info-bg-57f75969.jpeg";